/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface CashFlowGraphPlan$Params {
  id: string;

  /**
   * Номер страницы для пагинации данных.
   */
  page?: number;

  /**
   * Период агрегации данных. Возможные значения: 'month', 'year'.
   */
  period?: 'month' | 'year';
}

export function cashFlowGraphPlan(
  http: HttpClient,
  rootUrl: string,
  params: CashFlowGraphPlan$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }>
> {
  const rb = new RequestBuilder(rootUrl, cashFlowGraphPlan.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        /**
         * Список периодов (месяцы или годы).
         */
        category: Array<string>;
        series: Array<{
          data: Array<number>;
          title: string;
          code: string;
        }>;
      }>;
    }),
  );
}

cashFlowGraphPlan.PATH = '/api/project_calculations/cash_flow_plan_data/graph/{id}/';
